// extracted by mini-css-extract-plugin
export default {"wrapper":"mistakes_wrapper__8TLmV","title":"mistakes_title__CN4fB"};